import React, { useState } from "react";
import { Header, Text } from "@centrate-io/barn";

function Collateral(props) {
    const loan = props?.loan;
    console.log(loan);
    
    return (
        <div className="crumbs" style={{padding: 32}}>
        <Header type="display" size="5">
            Collateral
        </Header>
        </div> 
    );
  }
  
  export default Collateral;